<template>
    <div>
        <el-row>
            <el-col :span="18" :offset="3" v-loading="loading">
                <el-card class="box-card">
                    <CategoryRulesTable v-bind:tableData="tableData"/>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
  import {getAllCategoryRules} from "@/api/categoryRules.api";
  import CategoryRulesTable from "@/components/CategoryRulesTable";

  export default {
    name: "CategoryRulesPage",
    components: {
        CategoryRulesTable
    },
    data: () => ({
        tableData: [],
    }),
    async created() {
        this.reloadData()
    },
    methods: {
        async reloadData() {
            this.loading = true;

            const category_rules_response = await getAllCategoryRules();
            this.tableData = category_rules_response.data;

            this.loading = false;
        },
    }
  }
</script>

<style scoped>

</style>